module.exports = __webpack_public_path__ + "media/images/front-banner-dd0b8380083baa56d40c360f83422e09.png";